// rg-pack-dos-guantes: tarjetas "Guante 1 / Guante 2" de los packs de 2 guantes (snippets/rg-pack-dos-guantes.liquid):
// NIC ONE (opciones Talla × Modelo 1 × Modelo 2) y Storm (opción Talla; los modelos Fire/Sky no son opción).
//
// - Cada guante muestra tachadas las tallas sin stock de SU modelo, según el inventario del producto individual
//   (pedido del usuario 08-10: "sincronizadas con las tallas del inventario, no entre ellas"). Una talla tachada no se
//   puede elegir; si al cambiar de modelo la talla elegida queda sin stock, pasa a la más cercana disponible.
// - La variante del pack que se compra se elige entre las DISPONIBLES con esos modelos: primero la de la talla del
//   guante 1, si no la del guante 2, si no cualquiera. Lo que se despacha va en el pedido como "Guante 1" / "Guante 2"
//   (campos ocultos del snippet asociados al formulario de compra; se actualizan en cada cambio).
// - El selector nativo queda oculto en la página: estas tarjetas le hacen clic para cambiar la variante (precio, URL y
//   botón de compra se actualizan como siempre).
//
// Todo va por delegación en document (sirve también si el bloque aparece después, ej. un quick add).
(function () {
  if (window.__rgPack2) return;
  window.__rgPack2 = true;
  document.documentElement.classList.remove('rg-pack2-sin-js');

  function leerJson(root, sel) {
    try {
      return JSON.parse(root.querySelector(sel).textContent);
    } catch (e) {
      return null;
    }
  }

  function estado(root) {
    if (!root.__rg) {
      root.__rg = {
        modeloOpcion: root.dataset.modeloOpcion === 'true',
        t1: root.dataset.t1,
        t2: root.dataset.t1,
        m1: root.dataset.m1,
        m2: root.dataset.m2,
        variantes: leerJson(root, '[data-rg-pack2-variantes]') || [],
        modelos: leerJson(root, '[data-rg-pack2-modelos]') || {},
      };
    }
    return root.__rg;
  }

  // Solo se marca sin stock cuando el producto individual dice EXPLÍCITAMENTE que esa talla está agotada. Si el producto
  // individual no existe (handle cambiado, despublicado) o no tiene esa talla, no hay dato: se deja elegir y manda el
  // stock del pack (bug-check 09-10: antes quedaban todas las tallas tachadas y no se podía comprar).
  function hayModelo(e, modelo, talla) {
    var m = e.modelos[modelo];
    var s = m && m.stock;
    if (!s || !Object.prototype.hasOwnProperty.call(s, talla)) return true;
    return !!s[talla];
  }

  function tallasDe(root, g) {
    return Array.prototype.map.call(
      root.querySelectorAll('.rg-pack2__card[data-guante="' + g + '"] .rg-pack2__talla'),
      function (b) { return b.dataset.talla; }
    );
  }

  // Si la talla elegida no tiene stock en ese modelo, la disponible más cercana (o la misma si no hay ninguna).
  function corregirTalla(root, e, g) {
    var modelo = g === 1 ? e.m1 : e.m2;
    var talla = g === 1 ? e.t1 : e.t2;
    if (hayModelo(e, modelo, talla)) return talla;
    var lista = tallasDe(root, g);
    var i = lista.indexOf(talla);
    for (var d = 1; d < lista.length; d++) {
      if (i + d < lista.length && hayModelo(e, modelo, lista[i + d])) return lista[i + d];
      if (i - d >= 0 && hayModelo(e, modelo, lista[i - d])) return lista[i - d];
    }
    return talla;
  }

  function varianteObjetivo(e) {
    var candidatas = e.variantes.filter(function (v) {
      return v.a && (!e.modeloOpcion || (v.o2 === e.m1 && v.o3 === e.m2));
    });
    return (
      candidatas.find(function (v) { return v.o1 === e.t1; }) ||
      candidatas.find(function (v) { return v.o1 === e.t2; }) ||
      candidatas[0] ||
      null
    );
  }

  // Clic en la opción equivalente del selector nativo (posición 0 = talla, 1 = modelo 1, 2 = modelo 2).
  function elegirNativo(root, posicion, valor) {
    var scope = root.closest('[data-rg-pack2-scope]') || root.parentElement;
    var picker = scope && scope.querySelector('variant-picker');
    if (!picker || valor == null) return;
    var fieldsets = picker.querySelectorAll('fieldset');
    if (fieldsets.length) {
      var fs = fieldsets[posicion];
      var input = fs && Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (i) {
        return i.value === valor;
      });
      if (input && !input.checked) input.click();
      return;
    }
    var select = picker.querySelectorAll('select')[posicion];
    if (select && select.value !== valor) {
      select.value = valor;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Si ninguna variante del pack está disponible con esos modelos, se deja elegida igual la de esa combinación (agotada)
  // para que el propio botón del tema diga "Agotado" y no deje comprar otra variante distinta a la que dicen las tarjetas
  // (bug-check 09-10), y se avisa bajo las tarjetas.
  function varianteAgotada(e) {
    var todas = e.variantes.filter(function (v) {
      return !e.modeloOpcion || (v.o2 === e.m1 && v.o3 === e.m2);
    });
    return todas.find(function (v) { return v.o1 === e.t1; }) || todas[0] || null;
  }

  function avisoAgotado(root, agotado) {
    var nota = root.querySelector('.rg-pack2__nota');
    if (!nota) return;
    if (!nota.hasAttribute('data-texto-normal')) nota.setAttribute('data-texto-normal', nota.textContent);
    nota.textContent = agotado
      ? 'Esta combinación está agotada por ahora. Prueba con otros modelos.'
      : nota.getAttribute('data-texto-normal');
  }

  function sincronizarVariante(root, e) {
    var v = varianteObjetivo(e);
    avisoAgotado(root, !v);
    if (!v) v = varianteAgotada(e);
    if (!v) return;
    if (e.modeloOpcion) {
      elegirNativo(root, 1, v.o2);
      elegirNativo(root, 2, v.o3);
    }
    elegirNativo(root, 0, v.o1);
  }

  function pintar(root) {
    var e = estado(root);
    e.t1 = corregirTalla(root, e, 1);
    e.t2 = corregirTalla(root, e, 2);
    [1, 2].forEach(function (g) {
      var card = root.querySelector('.rg-pack2__card[data-guante="' + g + '"]');
      if (!card) return;
      var modelo = g === 1 ? e.m1 : e.m2;
      var talla = g === 1 ? e.t1 : e.t2;
      card.querySelectorAll('.rg-pack2__modelo').forEach(function (b) {
        b.setAttribute('aria-checked', String(b.dataset.modelo === modelo));
      });
      card.querySelectorAll('.rg-pack2__talla').forEach(function (b) {
        var sinStock = !hayModelo(e, modelo, b.dataset.talla);
        b.setAttribute('aria-checked', String(b.dataset.talla === talla));
        b.classList.toggle('is-agotado', sinStock);
        b.setAttribute('aria-disabled', String(sinStock));
      });
      var nombre = card.querySelector('[data-rg-nombre]');
      if (nombre) nombre.textContent = modelo.replace(/^Nic One /i, '');
      var foto = card.querySelector('.rg-pack2__foto');
      var m = e.modelos[modelo];
      if (foto && m && m.foto && foto.getAttribute('src') !== m.foto) {
        foto.removeAttribute('srcset');
        foto.src = m.foto;
        foto.alt = modelo;
      }
    });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.rg-pack2__modelo, .rg-pack2__talla');
    if (!btn) return;
    var root = btn.closest('[data-rg-pack2]');
    var card = btn.closest('.rg-pack2__card');
    if (!root || !card) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var e = estado(root);
    var g = card.dataset.guante;
    if (btn.dataset.modelo) {
      if (g === '1') e.m1 = btn.dataset.modelo;
      else e.m2 = btn.dataset.modelo;
    } else if (g === '1') {
      e.t1 = btn.dataset.talla;
    } else {
      e.t2 = btn.dataset.talla;
    }
    pintar(root);
    llenar(root);
    sincronizarVariante(root, e);
  });

  // Al cargar: tallas sin stock marcadas y variante del pack ajustada, sin esperar el primer clic.
  function inicial() {
    document.querySelectorAll('[data-rg-pack2]').forEach(function (root) {
      if (root.__rgPintado) return;
      root.__rgPintado = true;
      pintar(root);
      llenar(root);
      // El selector nativo (<variant-picker>) puede no estar definido todavía: un clic antes de eso no actualizaría la variante.
      customElements.whenDefined('variant-picker').then(function () {
        sincronizarVariante(root, estado(root));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicial);
  else inicial();
  if (window.__rgObservarCambiosDom) window.__rgObservarCambiosDom(inicial); // pack que aparece después (quick add)

  // Escribe modelo y talla de cada guante en los campos ocultos del selector (asociados al formulario de compra con
  // form=, ver el snippet). Como el selector no se redibuja, el valor sigue ahí cuando el tema agrega al carrito, incluso
  // si agrega después de terminar un cambio de variante.
  function llenar(root) {
    var e = estado(root);
    var c1 = root.querySelector('input[data-rg-pack-prop="1"]');
    var c2 = root.querySelector('input[data-rg-pack-prop="2"]');
    if (c1) c1.value = e.m1 + ' · talla ' + e.t1;
    if (c2) c2.value = e.m2 + ' · talla ' + e.t2;
  }
})();
